// Message keys
export const OVERVIEW_TITLE = 'age_verification.overview.title';
export const OVERVIEW_SUBTITLE = 'age_verification.overview.subtitle';
export const OVERVIEW_DISCLAIMER = 'age_verification.overview.disclaimer';
export const OVERVIEW_FOOTER = 'age_verification.overview.footer';

export const DOB_TITLE = 'age_verification.forms.dob.title';
export const DOB_DESCRIPTION = 'age_verification.forms.dob.description';

export const NAME_TITLE = 'age_verification.forms.name.title';
export const NAME_DESCRIPTION = 'age_verification.forms.name.description';

export const PHONE_NUMBER_TITLE = 'age_verification.forms.phone_number.title';

export const ADDRESS_TITLE = 'age_verification.forms.address.title';
export const ADDRESS_DESCRIPTION = 'age_verification.forms.address.description';
export const ADDRESS_SUBMIT = 'age_verification.forms.address.submit';

export const ALTERNATE_ADDRESS_DESCRIPTION =
  'age_verification.forms.alternate_address.description';

export const SSN_TITLE = 'age_verification.forms.ssn.title';
export const SSN_DESCRIPTION = 'age_verification.forms.ssn.description';

export const GENDER_TITLE = 'age_verification.forms.gender.title';
export const GENDER_PLACEHOLDER = 'age_verification.forms.gender.placeholder';

export const ERROR_UNEXPECTED = 'age_verification.errors.unexpected';

export const ERROR_NO_SUCH_STATE = 'age_verification.errors.no_such_state';
export const ERROR_ADDRESS_VERIFICATION =
  'age_verification.errors.address_verification';
export const PLACEHOLDER_DAY = 'age_verification.forms.placeholders.day';

export const PLACEHOLDER_MONTH = 'age_verification.forms.placeholders.month';
export const PLACEHOLDER_YEAR = 'age_verification.forms.placeholders.year';
export const PLACEHOLDER_STATE = 'age_verification.forms.placeholders.state';

export const LABEL_FIRST_NAME = 'age_verification.forms.labels.first_name';
export const LABEL_LAST_NAME = 'age_verification.forms.labels.last_name';
export const LABEL_ADDRESS_1 = 'age_verification.forms.labels.address_1';
export const LABEL_ADDRESS_2 = 'age_verification.forms.labels.address_2';
export const LABEL_CITY = 'age_verification.forms.labels.city';
export const LABEL_ZIP = 'age_verification.forms.labels.zip';
export const LABEL_SSN = 'age_verification.forms.labels.ssn';
export const LABEL_TAX_CODE = 'age_verification.forms.labels.tax_code';
export const LABEL_SSN_OPTOUT = 'age_verification.forms.labels.ssn_optout';
export const LABEL_JUMIO_OPTIN = 'age_verification.forms.labels.jumio_optin';
export const LABEL_JUMIO_OPTIN_PRIVACY_POLICY_LINK_TEXT =
  'age_verification.forms.labels.jumio_optin_privacy_policy_link_text';
export const LABEL_JUMIO_OPTIN_PRIVACY_POLICY_LINK_URL =
  'age_verification.forms.labels.jumio_optin_privacy_policy_link_url';
export const LABEL_JUMIO_OPTIN_TOS_LINK_TEXT =
  'age_verification.forms.labels.jumio_optin_tos_link_text';
export const LABEL_JUMIO_OPTIN_TOS_LINK_URL =
  'age_verification.forms.labels.jumio_optin_tos_link_url';

export const EXP_LABEL_GOVERNMENT_ID =
  'age_verification.forms.labels.experiment.government_id';
export const EXP_LABEL_UPLOAD_ID =
  'age_verification.forms.labels.experiment.upload_id';
export const EXP_LABEL_SSN = 'age_verification.forms.labels.experiment.ssn';
export const EXP_LABEL_ID_TIME =
  'age_verification.forms.labels.experiment.id_time';
export const EXP_LABEL_SSN_TIME =
  'age_verification.forms.labels.experiment.ssn_time';

export const ID_UPLOAD_TITLE = 'age_verification.id_upload.title';
export const ID_UPLOAD_SUBTITLE_ID =
  'age_verification.id_upload.subtitle.id_image';
export const ID_UPLOAD_DECRIPTION = 'age_verification.id_upload.description';
export const ID_UPLOAD_DECRIPTION_JUMIO =
  'age_verification.id_upload.description_jumio';
export const ID_UPLOAD_REMINDER = 'age_verification.id_upload.reminder';
export const ID_UPLOAD_OPT_IN_REQUIRED =
  'age_verification.id_upload.opt_in_required';
export const ID_UPLOAD_UPLOAD = 'age_verification.id_upload.upload';

export const FAIL_TITLE = 'age_verification.fail.title';
export const FAIL_DESCRIPTION = 'age_verification.fail.description';
export const FAIL_CONTACT_INFO = 'age_verification.fail.contact_info';
export const FAIL_SUPPORT_LINK_TEXT = 'age_verification.fail.support_link_text';

export const FAIL_DUPLICATE_TITLE = 'age_verification.fail_duplicate.title';
export const FAIL_DUPLICATE_DESCRIPTION =
  'age_verification.fail_duplicate.description';
export const FAIL_DUPLICATE_CONTACT_SUPPORT_TITLE =
  'age_verification.fail_duplicate.contact_support_title';
export const FAIL_DUPLICATE_CONTACT_SUPPORT_TEXT =
  'age_verification.fail_duplicate.contact_support_text';
export const FAIL_DUPLICATE_SIGN_IN_TEXT =
  'age_verification.fail_duplicate.sign_in_text';

export const RETENTION_PROGRESS_BAR_TITLE =
  'age_verification.retention.progressbar.title';
export const RETENTION_VIDEO_TITLE = 'age_verification.retention.video.title';

export const REVIEW_TITLE = 'age_verification.review.title';
export const REVIEW_DESCRIPTION = 'age_verification.review.description';

export const APPROVAL_TITLE = 'age_verification.approval.title';
export const APPROVAL_DESCRIPTION = 'age_verification.approval.description';

export const SUCCESS_TITLE = 'age_verification.success.title';
export const SUCCESS_DESCRIPTION = 'age_verification.success.description';

export const CONFIRMATION_MODAL_TITLE =
  'age_verification.confirmation_modal.title';
export const CONFIRMATION_MODAL_DESCRIPTION =
  'age_verification.confirmation_modal.description';
export const CONFIRMATION_MODAL_DISCLAIMER =
  'age_verification.confirmation_modal.disclaimer';

export const DOB_WARNING_MODAL_TITLE =
  'age_verification.dob_warning_modal.title';
export const DOB_WARNING_MODAL_DESCRIPTION =
  'age_verification.dob_warning_modal.description';
export const DOB_WARNING_MODAL_DISCLAIMER =
  'age_verification.dob_warning_modal.disclaimer';
export const DOB_WARNING_MODAL_SUPPORT_INFO =
  'age_verification.dob_warning_modal.support_info';
export const DOB_WARNING_MODAL_SUPPORT_INFO_LINK_TEXT =
  'age_verification.dob_warning_modal.support_info_link_text';
export const DOB_WARNING_MODAL_BUTTON_TEXT =
  'age_verification.dob_warning_modal.button_text';

export const LOGOUT = 'age_verification.logout';
export const LEARN_MORE = 'age_verification.learn_more';
export const CONTINUE = 'age_verification.continue';
export const CONFIRM = 'age_verification.confirm';
export const CANCEL = 'age_verification.cancel';

export const SUPPORT_URL = 'age_verification.support_url';
export const SUPPORT_WARRANTY_URL = 'age_verification.support_warranty_url';

export const CLAIM_WARRANTY = 'age_verification.claim_warranty';
export const WANT_TO_CLAIM_WARRANTY = 'age_verification.want_to_claim_warranty';

export const WARRANTY_ONLY_WARNING_TITLE =
  'age_verification.warranty_only_warning_title';
export const WARRANTY_ONLY_WARNING_BODY =
  'age_verification.warranty_only_warning_body';

export const LABEL_PASSPORT_NUMBER =
  'age_verification.forms.labels.passport_number';

export const BLOCKED_BY_POLICY_TITLE =
  'age_verification.blocked_by_policy.title';
export const BLOCKED_BY_POLICY_DESCRIPTION_1 =
  'age_verification.blocked_by_policy.description_1';
export const BLOCKED_BY_POLICY_DESCRIPTION_2 =
  'age_verification.blocked_by_policy.description_2';
export const BLOCKED_BY_POLICY_HAVE_QUESTIONS =
  'age_verification.blocked_by_policy.have_questions';
export const BLOCKED_BY_POLICY_CONTACT_SUPPORT =
  'age_verification.blocked_by_policy.contact_support';
export const BLOCKED_BY_POLICY_SUPPORT_URL =
  'age_verification.blocked_by_policy.support_url';
